import styled from "styled-components";

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .ant-btn {
    margin: 0 4px;
  }
`;
